import { useState } from 'react';
// API
import Api from '../../API';
// helpers
import {
  addBookToUserBooks,
  removeBookFromUserBooks,
} from '../../utils/helpers';

export const useAddDeleteUpdateBook = () => {
  const [loading, setLoading] = useState(false);
  const [responseError, setResponseError] = useState('');

  const addBookToList = async (book, listName) => {
    setLoading(true);
    setResponseError(false);

    return new Promise(async (resolve, reject) => {
      try {
        const response = await Api.addBookToList(book, listName);
        setLoading(false);

        if (response.error) {
          setResponseError(response.error);
        } else {
          setResponseError('');
          book.listName = listName;
          addBookToUserBooks(book);
        }
        resolve(response.error);
      } catch (error) {
        console.log(error);
      }
    });
  };

  const deleteBook = async (bookId) => {
    setLoading(true);
    setResponseError(false);

    return new Promise(async (resolve, reject) => {
      try {
        const response = await Api.deleteBook(bookId);
        setLoading(false);

        if (response.error) {
          setResponseError(response.error);
        } else {
          setResponseError('');
          removeBookFromUserBooks(bookId);
        }
        resolve(response.error);
      } catch (error) {
        console.log(error);
      }
    });
  };

  const updateBookPage = async (bookId, page) => {
    setLoading(true);
    setResponseError(false);

    return new Promise(async (resolve, reject) => {
      try {
        const response = await Api.updateBookCurrentPage(bookId, page);
        setLoading(false);

        if (response.error) {
          setResponseError(response.error);
        }
        resolve(response.error);
      } catch (error) {
        console.log(error);
      }
    });
  };

  return { loading, responseError, addBookToList, deleteBook, updateBookPage };
};
